import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';
import type { I18nState } from './types';

const initialState: I18nState = {
  translations: {},
  activeLanguage: LANGUAGE_CODE.de,
};

const reducer = (
  state: I18nState = initialState,
): I18nState => state;

export { reducer };
